module.exports = __webpack_public_path__ + "img/search.28a406f7.svg";